var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"articles"},[_c('div',{staticClass:"site-content animate"},[_c('main',{staticClass:"site-main"},[_c('article',{staticClass:"hentry"},[_c('header',{staticClass:"entry-header"},[_c('h1',{staticClass:"entry-title"},[_vm._v("抱歉，没有此文章！！！请按文章标题进行搜索")])])])])])])
}]

export { render, staticRenderFns }